<template>
  <!-- 基本信息 -->
  <div class="Minister-top information">
    <div class="Minister-top-top Ministerbackground">
      <div class="Minister-top-left Minister-top-color">类目属性</div>
    </div>
    <div class="information_content" style="margin-bottom: 20px">
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          平台分类
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input
              class="width67"
              v-model="formData.categoryName"
              maxlength="20"
              disabled
            ></el-input>
            <el-button
              v-if="(!isChakan && system == 5 && !isEdit) || !isEditLeimu"
              style="margin-left: 10px"
              type="primary"
              @click="openCategoryDialog"
            >
              选择类目
            </el-button>
            <el-button
              v-if="!isChakan && system == 5 && !isEdit && sellerId && name"
              style="margin-left: 10px"
              type="primary"
              @click="openTuijianDialog"
            >
              推荐类目
            </el-button>
          </div>
        </div>
      </div>

      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">产品属性</div>
        <div class="shuxing_box">
          <div
            class="item_shuxing"
            v-for="(item, index) in topShuxingArr"
            :key="index"
          >
            <div class="shuxing_label">
              <span class="shuxing_label_bitian" v-if="item.required">*</span>
              {{ item.enName }}({{ item.cnName }})
              <span v-if="item.unit">({{ item.unit }})</span>
            </div>
            <div style="width: 40%">
              <!--只能输入数字-->
              <el-input
                v-if="item.type == 'integer'"
                :disabled="isChakan || system < 5"
                class="shuxing_input"
                v-model="item.fieldValue"
                oninput="value=value.replace(/[^0-9]/g,'')"
                clearable
              >
              </el-input>
              <!--只能输入数字 小数点-->
              <el-input
                v-else-if="item.type == 'float'"
                :disabled="isChakan || system < 5"
                class="shuxing_input"
                v-model="item.fieldValue"
                oninput="value=value.replace(/[^0-9.]/g,'')"
                clearable
              >
              </el-input>
              <template v-else-if="item.type == 'dictionary'">
                <el-select
                  filterable
                  :multiple="
                    item.restrictions && item.restrictions.multipleChoices
                  "
                  v-model="item.fieldValue"
                  class="shuxing_select"
                  :disabled="isChakan || system < 5"
                  clearable
                >
                  <el-option
                    v-for="itemselect in item.parameterDictionaryList"
                    :key="itemselect.value"
                    :label="itemselect.label"
                    :value="itemselect.value"
                  ></el-option>
                </el-select>
              </template>
              <el-input
                v-else
                class="shuxing_input"
                v-model="item.fieldValue"
                clearable
                :disabled="isChakan || system < 5"
              >
              </el-input>
            </div>
            <div
              style="height: 100%; display: flex; align-items: center"
              v-if="!isChakan && system == 5"
            >
              <el-button
                icon="el-icon-plus"
                class="shuxing_button"
                @click="addToBianti(item, index)"
              ></el-button>
            </div>
            <div
              class="item_shuxing"
              style="width: 100%; margin-top: 4px; margin-bottom: 0"
              v-if="
                item.type == 'dictionary' &&
                item.options.customValuesEnabled &&
                isInnyStart(item.fieldValue, item.parameterDictionaryList)
              "
            >
              <div class="shuxing_label">
                <span class="shuxing_label_bitian" v-if="item.required">*</span>
                {{ item.enName }}（{{ item.cnName }})(自定义)
              </div>
              <div style="width: 40%">
                <el-input
                  placeholder="自定义"
                  v-model="item.values"
                  maxlength="20"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <leimu ref="leimu" @categoryAttr="categoryAttr"></leimu>
  </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from "../../../api/api/api";
import leimu from "./leimu.vue";
export default {
  name: "baseInfoComp",
  components: { leimu },
  data() {
    return {
      name: "",
      sellerId: "",
      isEditLeimu: false,
      saveArrOptions: [],
      // 类目
      topShuxingArr: [],
      formData: {
        categoryName: "", // 分类名称
        categoryId: "", // 分类id
      },
    };
  },
  props: {
    isChakan: {
      type: Boolean,
      default: false,
    },
    system: {
      type: Number,
      default: 5,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    //是否inny自定义开头【不区分大小写】
    isInnyStart(field, list) {
      if (field) {
        const str = list
          ?.find((ele) => ele.value === field)
          ?.label?.toLowerCase();
        return str?.startsWith("inny") || str?.startsWith("inna");
      }
      return false;
    },
    setName(name) {
      this.$refs.leimu.categorySearchText = name;
      this.name = name;
    },
    setSellerId(sellerId) {
      this.$refs.leimu.sellerId = sellerId;
      this.sellerId = sellerId;
    },
    initData() {
      this.formData.categoryName = "";
      this.topShuxingArr = [];
    },
    openCategoryDialog() {
      this.$refs.leimu.openDialog();
    },
    //打开推荐类目弹窗
    openTuijianDialog() {
      this.$refs.leimu.openDialog("tuijian");
    },
    //点击类目返回的属性
    categoryAttr(list, categoryName, categoryId) {
      this.$emit('setCategoryId',categoryId)
      this.saveArrOptions = JSON.parse(JSON.stringify(list));
      let arrList = list;
      this.formData.categoryName = categoryName;
      this.formData.categoryId = categoryId;
      arrList.forEach((item) => {
        //存放限定值  {multipleChoices:false} false单选,true多选
        if (item.restrictions) {
          item.restrictions = JSON.parse(item.restrictions);
        }
        if (item.options) {
          item.options = JSON.parse(item.options);
        }
        if (item.type == "string") {
          item.fieldValue = "";
        } else if (item.type == "integer") {
          item.fieldValue = undefined;
        } else if (item.type == "float") {
          item.fieldValue = undefined;
        } else if (item.type == "dictionary") {
          //这个是多选
          if (item.restrictions && item.restrictions.multipleChoices) {
            item.fieldValue = [];
          } else {
            item.fieldValue = undefined;
          }

          const filterFlag = item.name === "Marka" || item.name === "Producent" || item.name === "Producent części" || item.name === "Wydawnictwo";
          let selectDropList = item.parameterDictionaryList; //选择的下拉数据
          if (filterFlag) {
            selectDropList =
              (item.dictionary && JSON.parse(item.dictionary)) || [];
          }

          item.parameterDictionaryList = selectDropList.map((itemMap) => {
            return {
              label:
                itemMap.value +
                (itemMap.cnValue ? "(" + itemMap.cnValue + ")" : ""),
              value: filterFlag ? itemMap.id : itemMap.dictionaryId,
              pinjieName: itemMap.value,
              parameterId: item.parameterId,
              values: undefined,
            };
          });
        }
      });
      this.topShuxingArr = list.filter((item) => {
        return (
          !(item.options && item.options.variantsAllowed) &&
          item.parameterId != "225693"
        );
      });
      //EAN放到下方
      let bottomBiantiArr = list.filter((item) => {
        return (
          (item.options && item.options.variantsAllowed) ||
          item.parameterId == "225693"
        );
      });
      this.$emit("setBottomBiantiArr", bottomBiantiArr);
    },

    addToBianti(item, index) {
      this.topShuxingArr.splice(index, 1);
      this.topShuxingArr = [...this.topShuxingArr];
      //父组件添加变体属性
      this.$emit("addToBianti", item);
    },
    //增加下面移除的变体
    addTopAttrList(attrList) {
      this.topShuxingArr = this.topShuxingArr.concat(attrList);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../ozon.less";

.shuxing_box {
  min-height: 100px;
  background: rgb(238, 238, 238);
  border-radius: 10px;
  width: 88%;
  float: left;
  padding: 10px 0;
  font-size: 16px;

  .item_shuxing {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 4px;

    .shuxing_label {
      width: 40%;
      text-align: right;
      padding: 3px 10px;

      .shuxing_label_bitian {
        color: red;
        margin-right: 4px;
      }
    }

    .shuxing_input {
      width: 100%;
    }

    .shuxing_select {
      width: 100%;
    }

    .shuxing_button {
      width: 30px;
      height: 30px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgb(255, 183, 82);
      color: white;
      font-weight: 700;
      font-size: 20px;
      margin-left: 10px;
    }
  }
}

.input_bot_tip {
  display: flex;
  flex-direction: column;
}

.search_box {
  padding: 15px 10px;
  width: calc(100% - 20px);
  background: rgb(238, 238, 238);
  margin-top: 10px;
  display: flex;

  .search_box_item {
    width: 30%;
    margin-right: 20px;

    .leimu_box {
      height: 400px;
      padding: 10px;
      overflow-y: auto;
      background: white;

      .leimu_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: 5px 0;
        font-size: 16px;

        .leimu_item_desc {
          width: calc(100% - 20px);
          white-space: nowrap; /* 确保文本在一行内显示 */
          overflow: hidden; /* 隐藏溢出的内容 */
          text-overflow: ellipsis;
        }

        .item_leimu_you {
          color: rgb(82, 190, 166);
          margin-top: 3px;
        }
      }

      .select_leimu {
        border: 1px solid rgb(82, 190, 166);
        box-sizing: content-box;
      }

      .leimu_item:hover {
        border: 1px solid rgb(82, 190, 166);
        color: rgb(82, 190, 166);
        box-sizing: content-box;
      }
    }
  }
}

.search_box2 {
  padding: 15px 0px 15px 2px;
  width: calc(100%);
  background: rgb(238, 238, 238);
  margin-top: 10px;
}

.leimu_box2 {
  height: 400px;
  padding: 10px;
  overflow-y: auto;
  background: white;
  width: calc(100% - 20px);

  .leimu_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 7px 0;
    font-size: 14px;

    .leimu_item_desc {
      width: calc(100% - 20px);
      white-space: nowrap; /* 确保文本在一行内显示 */
      overflow: hidden; /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
    }

    .item_leimu_you {
      color: rgb(82, 190, 166);
      margin-top: 3px;
    }
  }

  .select_leimu {
    border: 1px solid rgb(82, 190, 166);
    box-sizing: content-box;
  }

  .leimu_item:hover {
    border: 1px solid rgb(82, 190, 166);
    color: rgb(82, 190, 166);
    box-sizing: content-box;
  }
}

.item_img {
  height: 16px;
  width: 16px;
  margin-left: 5px;
  cursor: pointer;
}

.el_tip_box {
  width: 360px;
  font-size: 16px;
  background: rgb(39, 39, 39);
  border-radius: 10px;
  padding: 8px;
  color: whitesmoke;
}
.shuxing_button {
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255, 183, 82);
  color: white;
  font-weight: 700;
  font-size: 20px;
  margin-left: 10px;
}
</style>
